<template>
    <modal
        :value="value"
        :max-width="650"
        title="Integrações permitidas"
        content-class="modal modal-round "
        closable
        @input="emitInput"
    >
        <section>
            <div
                v-for="(integration, index) in integrations"
                :key="`${index}-${integration.code}`"
                class="toggle-wrapper"
            >
                <app-toggle
                    :value="integrationsState[integration.code]"
                    @input="
                        onIntegrationUpdate({
                            code: integration.code,
                            isPresent: $event,
                        })
                    "
                />
                <span class="ml-2">{{ integration.name }}</span>
            </div>
        </section>
        <template #footer>
            <app-button
                class="btn btn-primary btn-round"
                :label="$t('message.generics.message.save')"
                primary
                :loading="loading"
                @click="updateIntegration"
            />
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import EventBus from "@packages/event-bus";
import AppToggle from "@components/Toggle";
import AppButton from "@/components/generic/button/Button";

export default {
    components: {
        Modal,
        AppToggle,
        AppButton,
    },

    data() {
        return {
            integrations: [],
            integrationsState: {},
            loading: false,
        };
    },

    props: {
        establishmentId: {
            type: Number,
            required: true,
        },
        value: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        emitInput(value) {
            this.$emit("input", value);
        },
        async loadIntegrations() {
            const response = await this.$api.establishmentIntegration.getAll(
                this.establishmentId
            );
            this.integrations = response;
            this.integrationsState = Object.fromEntries(
                response.map((integration) => [
                    integration.code,
                    integration.enabled,
                ])
            );
        },

        onIntegrationUpdate({ code, isPresent }) {
            this.integrationsState[code] = isPresent;
        },
        async updateIntegration() {
            try {
                this.loading = true;
                const enabledIntegrations = Object.entries(
                    this.integrationsState
                ).reduce((acc, [key, val]) => {
                    if (val) acc.push(key);
                    return acc;
                }, []);
                await this.$api.establishmentIntegration.update({
                    establishmentId: this.establishmentId,
                    integrations: enabledIntegrations,
                });
                this.$emit("on-update");
                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: "Integrações permitidas alteradas com sucesso",
                });
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
    },

    mounted() {
        this.loadIntegrations();
    },
};
</script>

<style scoped>
.toggle-wrapper {
    display: flex;
}
</style>
